<template>
  <li class="k-item " @click="handleClick(props.dataItem)">
    <span
      class="skuSearchName mt-2"
      role="option"
      :aria-selected="focused">
        <div class="locatorItemNameCell">
          <img
                :src="props.dataItem.fullProductImageUrl"
                :alt="t('cart.ProductImageAlt')"
                class="productSearchImage">
        </div>
        <div class="locatorItemNameCell">
          <div class="row">
            <div class="col-12">
                  {{ props.dataItem.productName }} - {{ props.dataItem.skuCode }}
            </div>
          </div>
        </div>
    </span>
  </li>
</template>


<script setup lang="ts">

import { useLogger } from 'vue-logger-plugin'
import { setStoreLogger } from '@/logger.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const logger = useLogger()
setStoreLogger(logger)

interface iViewModel {
  skuName: string
  skuCode: string
  productName: string
  fullProductImageUrl: string
}

const props = defineProps<{
    id: string,
    index: number,
    dataItem: iViewModel,
    textField: string,
    focused: boolean,
    selected: boolean
  }>()

logger.debug('AoeConsultantLocatorDetail dataItem', props.dataItem)

const emit = defineEmits(["selectedSku", "blur", "focus"]);

async function handleClick(dataItem: iViewModel) {
  logger.info('AoeSkuDetail.vue', 'handleClick', dataItem)
  emit('selectedSku', dataItem)
}

</script>

<style lang="scss">

.skuSearchName .k-animation-container {
  width: inherit !important;
}

.skuSearchName {
  display: grid;
  grid-template-columns: 25% 75%;
  padding: $spacing-2-5;
}

.locatorItemNameCell > div {
  padding: $spacing-1;
}

.productSearchImage
{
  width: 50px;
  height: 50px;
}

</style>
